

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['map_image', 'img_1', 'title_1', 'link_1', 'img_2', 'title_2', 'link_2', 'img_3', 'title_3', 'link_3'],
    },
  ],

  properties: {
    map_image: {
      title: 'Map Image',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    title_1: {
      title: 'Title 1',
    },
    title_2: {
      title: 'Title 2',
    },
    title_3: {
      title: 'Title 3',
    },
    link_1: {
      title: 'Link 1',
    },
    link_2: {
      title: 'Link 2',
    },
    link_3: {
      title: 'Link 3',
    },
    img_1: {
      title: 'Image 1 Path',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    img_2: {
      title: 'Image 2 Path',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
    img_3: {
      title: 'Image 3 Path',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: true,
      return: 'single',
    },
  },
  required: [],
});
